import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { GLOBAL_ENCRYPTION_KEY } from '../../constants';

import Aes256 from '../../helpers/Aes256';

const AuthStatePersistor = () => {
    const auth = useSelector((state) => state.auth);
    const gis = useSelector((state) => state.gis);
    const cargaInicial = useRef(true);

    useEffect(() => {
        if (auth.uid && !cargaInicial.current) {
            const aes256 = new Aes256();
            const encryptedAuth = aes256.encrypt(JSON.stringify(auth), GLOBAL_ENCRYPTION_KEY);
            const encryptedGisData= aes256.encrypt(JSON.stringify(gis), GLOBAL_ENCRYPTION_KEY);

            sessionStorage.setItem('authState', encryptedAuth.toString());
            sessionStorage.setItem('gisState', encryptedGisData.toString());
        } else {
            cargaInicial.current = false;
        }
    });

    return null;
};

export default AuthStatePersistor;
